import React from 'react'

import { MdArrowForwardIos } from 'react-icons/md'

import { useWindowSize } from '../../../hooks/useWindowSize'
import { getProfileImage } from '../../../utilFunctions/profileImage'

import { ListContainer, ItemWithImage, Photo } from './styles'

const ListWithImage = <
  T extends {
    uid: string
    name: string
    lastname: string
    image?: string
  },
>({
  disabled,
  list,
  activeId,
  onClick,
  hasSeparation = true,
}: {
  disabled: boolean
  list: Array<T> | null
  activeId?: string | null
  onClick: (index: number) => void
  hasSeparation?: boolean
}) => {
  const { isMobile } = useWindowSize()

  return (
    <ListContainer>
      {list &&
        list.map((item, i) => {
          return (
            <ItemWithImage
              className={`${disabled ? 'disabled' : ''} ${activeId === item.uid ? 'active' : ''}`}
              key={i}
              onClick={() => {
                if (!disabled) onClick(i)
              }}
              $hasSeparation={hasSeparation}
            >
              <Photo $image={getProfileImage(item.image)} />

              <p className="name">
                {item.name} {item.lastname}
              </p>
              {isMobile && activeId === item.uid && (
                <div className="icon">
                  <MdArrowForwardIos />
                </div>
              )}
            </ItemWithImage>
          )
        })}
    </ListContainer>
  )
}

export default ListWithImage
